import { combineReducers } from 'redux';
import localeReducer from './localeReducer';
import globalModalsReducer from './globalModalsReducer';
import userReducer from './userReducer';
import allClassroomsReducer from './allClassroomsReducer';
import allEducatorsReducer from './allEducatorsListReducer';
import specificClassroomReducer from './specificClassroomReducer';
import lectureReducer from './classroomLectureReducer';
import assignmentReducer from './classroomAssignmentReducer';
import chatRoomSocketReducer from './chatRoomSocketReducer';
import livestreamSocketReducer from './livestreamSocketReducer';
import calendarReducer from './classroomCalendarReducer';

const rootReducer = combineReducers({
  locale: localeReducer,
  modals: globalModalsReducer,
  user: userReducer,
  allClassrooms: allClassroomsReducer,
  allEducators: allEducatorsReducer,
  classroom: specificClassroomReducer,
  lectures: lectureReducer,
  assignments: assignmentReducer,
  chatSocket: chatRoomSocketReducer,
  streamSocket: livestreamSocketReducer,
  calendar: calendarReducer,
});

export default rootReducer;
